import type { SourceType } from '@hump/shared-types';
import type { Parser } from './types';
import { MarkdownParser } from './markdown';
import { PdfParser } from './pdf';
import { EpubParser } from './epub';
import { DocxParser } from './docx';
import { UrlParser } from './url';

const parsers: Partial<Record<SourceType, Parser>> = {
  md: new MarkdownParser(),
  pdf: new PdfParser(),
  epub: new EpubParser(),
  docx: new DocxParser(),
  url: new UrlParser(),
};

/** 获取指定来源类型的解析器 */
export function getParser(sourceType: SourceType): Parser {
  const parser = parsers[sourceType];
  if (!parser) {
    throw new Error(`No parser registered for sourceType: ${sourceType}`);
  }
  return parser;
}

/** 检查是否支持该来源类型 */
export function isSupported(sourceType: SourceType): boolean {
  return sourceType in parsers;
}

/** 判断文件扩展名（或 URL）对应的 sourceType */
export function sourceTypeFromFilename(filename: string): SourceType | null {
  // URL: http(s)://... → 触发 UrlParser
  // 对齐 features.md 1.5：URL 网页导入
  const trimmed = filename.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    return 'url';
  }
  const ext = trimmed.toLowerCase().split('.').pop();
  switch (ext) {
    case 'md':
    case 'markdown':
      return 'md';
    case 'pdf':
      return 'pdf';
    case 'epub':
      return 'epub';
    case 'docx':
      return 'docx';
    default:
      return null;
  }
}
